import { Marquee } from '@/components/ui/marquee';
import { Badge } from '@/components/ui/badge';
import {
  Clock,
  Brain,
  Calendar,
  CalendarDays,
  Mail,
  KeyRound,
  BellRing,
  AlarmClock,
  ClipboardList,
  ShieldCheck,
  UserCog,
  BarChart3,
  Globe,
  Layers,
  BookOpen,
  ThumbsUp,
  Link2,
} from 'lucide-react';

const row1 = [
  { icon: Clock, label: 'SLA Tracking' },
  { icon: Brain, label: 'AI Classification' },
  { icon: Calendar, label: 'Business Hours' },
  { icon: CalendarDays, label: 'Holiday Calendars' },
  { icon: Mail, label: 'Email Threading' },
  { icon: KeyRound, label: 'Magic Link Auth' },
  { icon: BellRing, label: 'Push Notifications' },
  { icon: BookOpen, label: 'Knowledge Base' },
];

const row2 = [
  { icon: AlarmClock, label: 'Ticket Reminders' },
  { icon: ClipboardList, label: 'Audit Logs' },
  { icon: ShieldCheck, label: 'Role-Based Access' },
  { icon: UserCog, label: 'Agent Management' },
  { icon: BarChart3, label: 'Analytics Dashboard' },
  { icon: Globe, label: 'Multi-Tenant' },
  { icon: Layers, label: 'Custom Categories' },
  { icon: ThumbsUp, label: 'Article Feedback' },
  { icon: Link2, label: 'Ticket-Article Linking' },
];

function CapabilityBadge({ icon: Icon, label }: { icon: React.ElementType; label: string }) {
  return (
    <Badge variant="outline" className="flex items-center gap-2 px-4 py-2 text-sm whitespace-nowrap">
      <Icon className="h-4 w-4 text-primary" />
      {label}
    </Badge>
  );
}

export function CapabilitiesMarquee() {
  return (
    <section className="py-12 px-4 overflow-hidden">
      <div
        className="relative"
        style={{
          maskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
          WebkitMaskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
        }}
      >
        <Marquee pauseOnHover className="[--duration:30s] mb-4">
          {row1.map((item) => (
            <CapabilityBadge key={item.label} {...item} />
          ))}
        </Marquee>
        <Marquee reverse pauseOnHover className="[--duration:35s]">
          {row2.map((item) => (
            <CapabilityBadge key={item.label} {...item} />
          ))}
        </Marquee>
      </div>
    </section>
  );
}
